// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Execution results summed across every test plan linked to this build.
 * @export
 * @interface BuildTraceabilityResults
 */
export interface BuildTraceabilityResults {
  /**
   * Total cases across the build's plans (executed + unexecuted).
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  passed?: number;
  /**
   *
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  failed?: number;
  /**
   *
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  blocked?: number;
  /**
   *
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  skipped?: number;
  /**
   *
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  unexecuted?: number;
  /**
   * Cases with any real (non-unexecuted) status.
   * @type {number}
   * @memberof BuildTraceabilityResults
   */
  executed?: number;
  /**
   * Count keyed by status system_name, including custom project statuses.
   * @type {{ [key: string]: number; }}
   * @memberof BuildTraceabilityResults
   */
  byStatus?: { [key: string]: number };
  /**
   * TCV-6814. Executed cases keyed by how the result was produced (manual, ci, api, agent, import), plus `not_recorded` for results predating this being tracked. Answers how much of the build was verified automatically. Only executed cases are counted — an unexecuted case has no producer.
   * @type {{ [key: string]: number; }}
   * @memberof BuildTraceabilityResults
   */
  bySource?: { [key: string]: number };
}

export function BuildTraceabilityResultsFromJSON(
  json: any
): BuildTraceabilityResults {
  return {
    total: !exists(json, "total") ? undefined : json["total"],
    passed: !exists(json, "passed") ? undefined : json["passed"],
    failed: !exists(json, "failed") ? undefined : json["failed"],
    blocked: !exists(json, "blocked") ? undefined : json["blocked"],
    skipped: !exists(json, "skipped") ? undefined : json["skipped"],
    unexecuted: !exists(json, "unexecuted") ? undefined : json["unexecuted"],
    executed: !exists(json, "executed") ? undefined : json["executed"],
    byStatus: !exists(json, "by_status") ? undefined : json["by_status"],
    bySource: !exists(json, "by_source") ? undefined : json["by_source"],
  };
}

export function BuildTraceabilityResultsToJSON(
  value?: BuildTraceabilityResults
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    total: value.total,
    passed: value.passed,
    failed: value.failed,
    blocked: value.blocked,
    skipped: value.skipped,
    unexecuted: value.unexecuted,
    executed: value.executed,
    by_status: value.byStatus,
    by_source: value.bySource,
  };
}
